import React, { useReducer, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import axios from "axios";
import { adminMainUrl } from "../../../../Config";
import { useDispatch, useSelector } from "react-redux";
import { getLedgerAccountDetail } from "../../../../Redux/action/Account/AccountMasterAction";
import LedgerAccountView from "./LedgerAccountView";
import { useLocation, useNavigate } from "react-router-dom";
import LedgerAccountEdit from "./LedgerAccountEdit";

const LedgerAccountList = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const dispatch = useDispatch();
  const [ledgerAccountSearch, setLedgerAccountSearch] = useState({
    from_date: "",
    to_date: "",
    gst: "",
    party_name: "",
  });
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setLedgerAccountSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const ClearForm = () => {
    setLedgerAccountSearch({
      from_date: "",
      to_date: "",
      gst: "",
      party_name: "",
    });
  };

  const searchHandler = async () => {
    // console.log("data", ledgerAccountSearch);
    const { from_date, to_date, gst, party_name } = ledgerAccountSearch;
    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/ledger-account`;
    const queryParams = [];
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (gst) queryParams.push(`gst=${gst}`);
    if (party_name) queryParams.push(`party_name=${party_name}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }
    try {
      const { data } = await axios.get(apiUrl, config);
      // console.log("res", data.data);
      setTableData(data.data);
    } catch (error) {
      console.error("Error fetching receipt vouchers:", error);
    }
  };


  //view ledger details
  const [showLedgerDetail, setShowLedgerDetail] = useState(false);
  const [showLedgerEdit, setShowLedgerEdit] = useState(false);
  const handleCloseLedgerDetail = () => setShowLedgerDetail(false);
  const handleCloseLedgerEdit = () => setShowLedgerEdit(false);

  const handleViewLedger = (id) => {
    if (!id) {
      toast.error("ID is required.");
      return;
    }
    dispatch(getLedgerAccountDetail(token, user_id, id));
    setShowLedgerDetail(true);
  };

  const handleEditLedger = (id) => {
    if (!id) {
      toast.error("ID is required.");
      return;
    }
    dispatch(getLedgerAccountDetail(token, user_id, id));
    setShowLedgerEdit(true);
  };

  const refreshLedger = (id) => {
    if (!id) {
      toast.error("ID is required.");
      return;
    }
    dispatch(getLedgerAccountDetail(token, user_id, id));
    handleCloseLedgerEdit();
    searchHandler();
  }

  const { loadingLedgerAccountDetail,
    LedgerAccountDetail,
    LedgerAccountDetailError } = useSelector(state => state?.AccountMasterReducer);


  useEffect(() => {
    if (token && user_id) {
      searchHandler()
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }

  }, [])
  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>

      <div className="">
        <h5 className="fw-semibold mb-3">Search Ledger Account</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={ledgerAccountSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={ledgerAccountSearch.to_date}
            />
          </div>

          {/* gst */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">GST</label>
            <input
              type="text"
              name="gst"
              className="form-control bg-light"
              placeholder="Enter GST"
              onChange={onValueChange}
              value={ledgerAccountSearch.gst}
            />
          </div>

          {/* party name */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Party Name</label>
            <input
              type="text"
              name="party_name"
              className="form-control bg-light"
              placeholder="Enter Party Name"
              onChange={onValueChange}
              value={ledgerAccountSearch.party_name}
            />
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => searchHandler()}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-search me-1"></i> Search
            </button>

            <button
              onClick={() => ClearForm()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>
          </div>
        </div>
      </div>

      <div className="card p-4 mt-3">
        <h5 className="fw-semibold mb-3">Ledger Accounts</h5>

        {/*  Make TABLE Responsive  */}
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Ledger GST</th>
                <th>Party Name</th>
                <th>Date</th>
                <th>Opening Balance</th>
                <th>Credit Limit</th>
                <th>Credit Day</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {tableData?.map((row) => (
                <tr key={row.id}>
                  <td>{row.ledger_gst}</td>
                  <td>{row.ledger_party_name}</td>
                  <td>{row.createdAt.split("T")[0]}</td>
                  <td>{row.ledger_opening_balance}</td>
                  <td>{row.ledger_credit_limit}</td>
                  <td>{row.ledger_credit_day}</td>
                  <td><button className="btn btn-sm mx-2" onClick={() => { handleViewLedger(row.id) }}>View</button>
                    <button className="btn btn-sm" onClick={() => { handleEditLedger(row.id) }}>Edit</button></td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


      <LedgerAccountView
        loadingLedgerAccountDetail={loadingLedgerAccountDetail}
        LedgerAccountDetail={LedgerAccountDetail}
        LedgerAccountDetailError={LedgerAccountDetailError}
        showLedgerDetail={showLedgerDetail}
        handleCloseLedgerDetail={handleCloseLedgerDetail}
      />
      <LedgerAccountEdit
        loadingLedgerAccountDetail={loadingLedgerAccountDetail}
        LedgerAccountDetail={LedgerAccountDetail}
        LedgerAccountDetailError={LedgerAccountDetailError}
        showLedgerDetail={showLedgerEdit}
        handleCloseLedgerDetail={handleCloseLedgerEdit}
        refreshLedger={refreshLedger}
      />
    </>
  );
};

export default LedgerAccountList;
